// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import React from "react";

import ESAFundsBanner from "../../Banners/ESAFundsBanner";
import NorthCarolinaESABanner from "../../Banners/NorthCarolinaESABanner";
import { TEACHER_CERTIFICATE_STATE_MAP } from "../../Teachers/constants";
import { ParentCtaInterface } from "./types";

export const DEFAULT_CTAS: ParentCtaInterface[] = [
  {
    name: "NorthCarolinaESAFunds",
    isEligible: ({ currentUser, ipInfo }) => {
      if (currentUser?.location?.state) {
        return (
          currentUser?.location?.state ===
          TEACHER_CERTIFICATE_STATE_MAP.NorthCarolina
        );
      } else {
        return Boolean(
          ipInfo?.country?.isoCode === "US" &&
            !!(ipInfo?.subdivisions || []).find(
              subdivision => subdivision.isoCode === "NC"
            )
        );
      }
    },
    Component: () => <NorthCarolinaESABanner />,
  },
  {
    name: "ESAFunds",
    isEligible: ({ currentUser, ipInfo }) => {
      if (currentUser?.location?.state) {
        return (
          currentUser?.location?.state === TEACHER_CERTIFICATE_STATE_MAP.Arizona
        );
      } else {
        return Boolean(
          ipInfo?.country?.isoCode === "US" &&
            !!(ipInfo?.subdivisions || []).find(
              subdivision => subdivision.isoCode === "AZ"
            )
        );
      }
    },
    Component: () => <ESAFundsBanner />,
  },
];
